export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-dropbox-adde3e3d8af98b32fad8ce2c923060ab.svg";